<template>
  <div>
    <Header />
    <router-view />
    <UserLoading v-if="loading" />
  </div>
</template>

<script>
import UserLoading from "./Loading";
import { mapState } from "vuex";
import Header from "./HeaderGuest";
export default {
  name: "GuestLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    UserLoading,
    Header
  },
  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    })
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/auth.scss";
</style>
